import { render, staticRenderFns } from "./InventorySurplusRecord.vue?vue&type=template&id=05398793&scoped=true"
import script from "./InventorySurplusRecord.vue?vue&type=script&lang=js"
export * from "./InventorySurplusRecord.vue?vue&type=script&lang=js"
import style0 from "./InventorySurplusRecord.vue?vue&type=style&index=0&id=05398793&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05398793",
  null
  
)

export default component.exports